import { Layout, Menu, Button, Grid, Card, Typography, Drawer } from 'antd';
import {
  FileTextOutlined,
  UserOutlined,
  SettingOutlined,
  ApartmentOutlined,
  MenuOutlined,
} from '@ant-design/icons';
import { useState, useEffect, useMemo } from 'react';
import { Link, useLocation, useNavigate, useParams } from 'react-router-dom';
const { Text } = Typography;

const { Header, Sider, Content } = Layout;
const { useBreakpoint } = Grid;

const menuItems = [
  {
    key: 'certificates',
    icon: <FileTextOutlined />,
    label: <Link to="/certificates">Удостоверения</Link>,
    title: 'Удостоверения',
    path: '/certificates',
  },
  {
    key: 'objects',
    icon: <ApartmentOutlined />,
    label: <Link to="/objects">Оборудование</Link>,
    title: 'Оборудование',
    path: '/objects',
  },
  {
    key: 'profile',
    icon: <UserOutlined />,
    label: <Link to="/profile">Мой профиль</Link>,
    title: 'Мой профиль',
    path: '/profile',
  },
  {
    key: 'settings',
    icon: <SettingOutlined />,
    label: <Link to="/settings">Настройки</Link>,
    title: 'Настройки',
    path: '/settings',
  },
];

export default function AppLayout({ children }) {
  const screens = useBreakpoint();
  const isMobile = !screens.md;
  const location = useLocation();
  const navigate = useNavigate();

  const [currentKey, setCurrentKey] = useState('');
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  useEffect(() => {
    const matched = menuItems.find((item) => location.pathname.startsWith(item.path));
    setCurrentKey(matched?.key || '');
  }, [location.pathname]);

  const handleMenuClick = (e) => {
    setCurrentKey(e.key);
    if (isMobile) setMobileMenuOpen(false);
  };

  // Dynamic page title for mobile header
  const pageTitle = useMemo(() => {
    const path = location.pathname;
    if (path === '/certificates') return 'Удостоверения';
    if (/^\/certificates\/\d+/.test(path)) return 'Удостоверение';
    if (path === '/objects') return 'Оборудование';
    if (/^\/objects\/\d+\/equipment\/\d+/.test(path)) return 'Оборудование';
    if (/^\/objects\/\d+/.test(path)) return 'Объект';
    if (path === '/profile') return 'Мой профиль';
    if (path === '/settings') return 'Настройки';
    return '';
  }, [location.pathname]);

  return (
    <Layout style={{ height: '98vh' }}>
      {!isMobile && (
        <Sider width={200} theme="light" style={{ paddingTop: 16, overflow: 'auto' }}>
          {/* Логотип */}
  <div
    onClick={() => navigate('/certificates')}
    style={{
      cursor: 'pointer',
      display: 'flex',
      alignItems: 'center',
      padding: '0 16px 16px 16px',
      fontWeight: 'bold',
      fontSize: 16,
      gap: 8,
    }}
  >
    <img
      src="https://tmg-din.ru/img/logo.svg"
      alt="logo"
      style={{
        width: 36,
        height: 36,
        filter: 'invert(31%) sepia(99%) saturate(7496%) hue-rotate(203deg) brightness(96%) contrast(101%)',
      }}
    />
    <Text>
        Реестр
    </Text>
  </div>


          {/* Меню */}
          <Menu
            mode="inline"
            selectedKeys={[currentKey]}
            items={menuItems.map(({ key, icon, label }) => ({
              key,
              icon,
              label,
            }))}
            onClick={handleMenuClick}
            style={{ borderRight: 0 }}
          />
        </Sider>
      )}

      <Layout style={{ height: '100%' }}>
        {isMobile && (
          <>
            <Header
              style={{
                background: '#fff',
                padding: '0 12px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                minHeight: 48,
                height: 48,
                lineHeight: '48px',
              }}
            >
              <img
                src="https://tmg-din.ru/img/logo.svg"
                alt="logo"
                onClick={() => navigate('/certificates')}
                style={{
                  width: 28,
                  height: 28,
                  cursor: 'pointer',
                  filter: 'invert(31%) sepia(99%) saturate(7496%) hue-rotate(203deg) brightness(96%) contrast(101%)',
                  flexShrink: 0,
                }}
              />
              <Text strong style={{ fontSize: 16, position: 'absolute', left: '50%', transform: 'translateX(-50%)' }}>
                {pageTitle}
              </Text>
              <Button
                type="text"
                icon={<MenuOutlined style={{ fontSize: 20 }} />}
                onClick={() => setMobileMenuOpen(true)}
                style={{ padding: '4px 8px', flexShrink: 0 }}
              />
            </Header>

            <Drawer
              open={mobileMenuOpen}
              onClose={() => setMobileMenuOpen(false)}
              placement="right"
              width="100%"
              closable
              title={
                <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                  <img
                    src="https://tmg-din.ru/img/logo.svg"
                    alt="logo"
                    style={{
                      width: 28,
                      height: 28,
                      filter: 'invert(31%) sepia(99%) saturate(7496%) hue-rotate(203deg) brightness(96%) contrast(101%)',
                    }}
                  />
                  <span>Реестр</span>
                </div>
              }
              styles={{ body: { padding: 0 } }}
            >
              <Menu
                mode="inline"
                selectedKeys={[currentKey]}
                items={menuItems.map(({ key, icon, label }) => ({
                  key,
                  icon,
                  label,
                }))}
                onClick={handleMenuClick}
                style={{ border: 'none', fontSize: 16 }}
              />
            </Drawer>
          </>
        )}

        <Content style={{ padding: 6, backgroundColor: 'white', overflow: 'auto', height: '100%' }}>
          {isMobile?
            children
            :
            <Card style={{ height: '100%' }}>{children}</Card>
          }        
        </Content>
      </Layout>
    </Layout>
  );
}
